<!-- シートマップ -->
<template>
  <TemplateMfittBooking4
    v-if="isReadyToDraw"
    v-model:selectedCar="selectedCar"
  />

  <!-- 描画ローディング -->
  <DialogInitialLoading v-else :timeoutSeconds="7000" />

  <!-- 購入期限を超えて座席指定しようとした場合のエラーダイアログ -->
  <DialogCanNotGoToSheetMapByPurchaseLimit
    ref="DialogCanNotGoToSheetMapByPurchaseLimit"
    :closeButtonClicked="backToBooking3Page"
  />

  <!-- 予約期限を超えて座席指定しようとした場合のエラーダイアログ -->
  <DialogCanNotReserveBecauseOverLimit
    ref="DialogCanNotReserveBecauseOverLimit"
    :closeButtonClicked="backToBooking3Page"
  />

  <!-- 電波状況が悪い場合のダイアログ -->
  <DialogBadReception
    ref="DialogBadReception"
    :closeButtonClicked="backToBooking3Page"
  />

  <DialogDuringMaintenance
    ref="DialogDuringMaintenance"
    :closeButtonClicked="backToBooking3Page"
  />

  <DialogUnexpectedError
    ref="DialogUnexpectedError"
    :closeButtonClicked="backToBooking3Page"
  />
</template>

<script>
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

import TemplateMfittBooking4 from "@/views/Templates/MFITT/TemplateMfittBooking4";

import API from "@/API";

import nativeHandlerService from "@/services/nativeHandler";
import { COMMON_SPECIAL_DESIGNATIONS_MAP, CAR_SPECIAL_DESIGNATIONS_MAP } from "@/lib/constants";
export default {
  name: "MfittBooking4",
  components: { TemplateMfittBooking4 },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const DialogCanNotGoToSheetMapByPurchaseLimit = ref(null);
    const DialogCanNotReserveBecauseOverLimit = ref(null);
    const DialogBadReception = ref(null);
    const DialogUnexpectedError = ref(null);
    const DialogDuringMaintenance = ref(null);

    const isReadyToDraw = ref(false);

    const selectedCar = ref({});
    // 号車の座席情報を取得する
    onMounted(async () => {
      // 選ばれた列車情報
      const selectedTrainInfo =
        store.getters["MFITT/vacancyInquiry"].train_info[route.params.id];

      // フロントの格納情報
      const inputtedInfoOnBooking =
        store.getters["MFITT/inputtedInfoOnBooking"];

      // 指定するcar_idの洗い出し
      // 一般席・前展望は0番
      // 後展望は一番後ろ
      // サルーンは3号車固定
      switch (inputtedInfoOnBooking.special_designation.id) {
        case COMMON_SPECIAL_DESIGNATIONS_MAP.GENERAL:
          selectedCar.value = selectedTrainInfo.cars_formation.cars[0];
          break;
        case COMMON_SPECIAL_DESIGNATIONS_MAP.FRONT_VIEW:
          if (inputtedInfoOnBooking.bound == 0) {
            selectedCar.value =
              selectedTrainInfo.cars_formation.cars[
                Number(selectedTrainInfo.cars_formation.cars.length - 1)
              ];
          } else {
            selectedCar.value = selectedTrainInfo.cars_formation.cars[0];
          }
          break;
        case COMMON_SPECIAL_DESIGNATIONS_MAP.REAR_VIEW:
          if (inputtedInfoOnBooking.bound == 0) {
            selectedCar.value = selectedTrainInfo.cars_formation.cars[0];
          } else {
            selectedCar.value =
              selectedTrainInfo.cars_formation.cars[
                Number(selectedTrainInfo.cars_formation.cars.length - 1)
              ];
          }
          break;
        case COMMON_SPECIAL_DESIGNATIONS_MAP.SALOON:
          selectedCar.value = selectedTrainInfo.cars_formation.cars[2];
          break;
        case CAR_SPECIAL_DESIGNATIONS_MAP.A:
        case CAR_SPECIAL_DESIGNATIONS_MAP.B:
        case CAR_SPECIAL_DESIGNATIONS_MAP.C:
        case CAR_SPECIAL_DESIGNATIONS_MAP.D:
        case CAR_SPECIAL_DESIGNATIONS_MAP.E:
        case CAR_SPECIAL_DESIGNATIONS_MAP.F:
        case CAR_SPECIAL_DESIGNATIONS_MAP.G:
        case CAR_SPECIAL_DESIGNATIONS_MAP.H:
        case CAR_SPECIAL_DESIGNATIONS_MAP.I:
        case CAR_SPECIAL_DESIGNATIONS_MAP.J:
          const specialCar = selectedTrainInfo.cars_formation.cars.find(
            (car) => car.is_exclusive && car.exclusive_car_name === inputtedInfoOnBooking.special_designation.label
          );
          selectedCar.value = specialCar || {};
          break;
      }
      try {
        await API.getCarNumberVacancyStatus(
          selectedTrainInfo,
          selectedCar.value.id
        );
        isReadyToDraw.value = true;
      } catch (e) {
        if (e.response.data.message) {
          // 予約期限(発車45分前)を過ぎている場合
          if (
            e.response.data.message ===
            "departure_at号車空席照会は発車時刻の45分前まで可能です"
          ) {
            DialogCanNotReserveBecauseOverLimit.value.openDialog();
            // 購入期限(発車3分前)を過ぎている場合
          } else if (
            e.response.data.message ===
            "departure_at号車空席照会は発車時刻の3分前まで可能です"
          ) {
            DialogCanNotGoToSheetMapByPurchaseLimit.value.openDialog();
          } else if (e.response.data.message === "回線が込み合っています") {
            DialogBadReception.value.openDialog();
            // MWのメンテナンス中
          } else if (e.response.status == 503) {
            DialogDuringMaintenance.value.openDialog(e.response.data);
          } else {
            // nativeにエラー内容送信
            nativeHandlerService.ncSendMfittError(e.response.data.message);
            DialogUnexpectedError.value.openDialog();
          }
        } else {
          nativeHandlerService.ncSendMfittError("MFITTBooking4 onMounted()");
        }
      }
    });

    const backToBooking3Page = () => {
      router.push({
        name: "MfittBooking3",
        params: { id: route.params.id },
        query: {
          coupon_id: route.query.coupon_id,
          changing_limited_express_ticket_id:
            route.query.changing_limited_express_ticket_id,
        },
      });
    };

    return {
      isReadyToDraw,
      DialogBadReception,
      DialogCanNotGoToSheetMapByPurchaseLimit,
      DialogCanNotReserveBecauseOverLimit,
      DialogUnexpectedError,
      DialogDuringMaintenance,
      selectedCar,
      backToBooking3Page,
    };
  },
};
</script>
